import React from 'react';

export default function FormWrapper({ children }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-200 p-4">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg sm:max-w-lg md:max-w-xl">
        {children}
      </div>
    </div>
  );
}
